import { useContext } from 'react';

import type { TruncationMode } from '../../../typography/text-ellipsis/TextEllipsis.js';
import { CategoricalBarChartTruncationModeContext } from '../contexts/CategoricalBarChartTruncationMode.context.js';

export const useTruncationMode = (): TruncationMode =>
  useContext(CategoricalBarChartTruncationModeContext);
